import React from "react";
import { element } from 'prop-types';
import "./App.css";
import Content from "../shared/component/layouts/content";
const App = props => (
    <div className="App">
      <header className="App-header">
        {/* <img src={profile} className="profile-image"></img>
        
          <link href="https://fonts.googleapis.com/css?family=Cookie" rel="stylesheet"></link>
            <a className="bmc-button" target="_blank" href="https://www.buymeacoffee.com/gumboy">
              <img src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg" alt="Buy me a coffee"></img>
                <span style={{marginLeft:'15px',fontSize:'28px !important'}}>Buy me a coffee</span></a> */}

        <Content>
          {props.children}
        </Content>
      </header>
    </div>

);

App.propTypes = {
  children: element
  };
export default App;
